var _this = this;
import { createHashHistory } from 'history';
import { get } from '../ajax';
import tokenErrorActions from '../tokenErrorActionCreators';
import { constantsRegistry } from '../../constants/tableConstantsFactory';
import routeHelper from '../../components/common/classes/routeHelper';
const hashHistory = createHashHistory();

/**
 *  @param entity the entity name: e.g. "report"
 *  @param entityRoute the base route to get to the entity: e.g. "reports"
 */
const detailActionFactory = (entity, entityRoute) => {
  // if these constants have any custom values, they should be imported
  // before getting to this point.
  const constants = constantsRegistry(entity);
  const doesNotExistError = () => {
    const baseURL = hashHistory.location.pathname.split(entityRoute).shift().concat(entityRoute);
    routeHelper.handleEntityDoesNotExist(baseURL);
    return {
      type: constants.ERROR_DOES_NOT_EXIST
    };
  };

  /* we might need some user input before we can do the transition.
   */
  const showCancel = () => ({
    type: constants.SHOW_CANCEL
  });
  const show = id => ({
    type: constants.SHOW,
    id
  });
  const showFail = e => ({
    type: constants.SHOW_FAIL,
    payload: e
  });
  const showSuccess = (id, data, query) => ({
    type: constants.SHOW_SUCCESS,
    id,
    data,
    query
  });

  //* ***********  SERVER INTERACTION METHODS  *******************

  const _serverShow = function serverShow(id) {
    let query = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
    let successFunc = arguments.length > 2 ? arguments[2] : undefined;
    let failureFunc = arguments.length > 3 ? arguments[3] : undefined;
    let handleRedirect = arguments.length > 4 ? arguments[4] : undefined;
    return async dispatch => {
      const onSuccess = successFunc !== undefined ? successFunc : showSuccess;
      // the result of serverShow gets called with the dispatch method and
      // a function to access the redux state.
      dispatch(show(id));
      const url = "/".concat(entityRoute, "/").concat(id);
      try {
        const response = await get(url, query);
        if (!response.data || Object.keys(response.data).length <= 0) {
          dispatch(showFail());
          if (failureFunc !== undefined) {
            return dispatch(failureFunc());
          }
          return dispatch(doesNotExistError());
        }
        return dispatch(onSuccess(id, response.data, query));
      } catch (e) {
        return dispatch(tokenErrorActions.handleError(e, entity, showFail.bind(_this, e), _serverShow.bind(_this, id, query), handleRedirect));
      }
    };
  };

  // we need to return an object with all the creators defined.
  return {
    doesNotExistError,
    serverShow: _serverShow,
    show,
    showCancel,
    showFail,
    showSuccess
  };
};
export default detailActionFactory;